import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import MediaItem from '../MediaItem/MediaItem.jsx'
import { FaSpinner } from 'react-icons/fa'
import { Spinner } from 'react-bootstrap'


export default function Home({ setIsLogged, isLogged }) {

  const [trendingPeople, setTrendingPeople] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  async function getTrending(mediaType, callback) {
    let { data } = await Axios.get(`https://api.themoviedb.org/3/trending/person/week?api_key=86a23d94aa6567f63245ba13568ede00`)
    setTrendingPeople(data.results);
    setIsLoading(false)
  }

  useEffect(() => {
    getTrending();
  }, [])


  return (
    isLoading ? <>
      <div className="d-flex flex-row justify-content-center align-content-center h-100">
        {/* <FaSpinner style={{fontSize:'90px'}}/> */}
        <Spinner animation='grow' variant='secondary' style={{ width: '200px', height: '200px', padding: 30 }} />
      </div>
    </> :
      <>
        <div className="row py-5">
          <div className="col-md-4 d-flex align-items-center ">
            <div>
              <div className="brdr w-25 mb-3 "></div>
              <h1 className='h4'>Trending People <br /> To Watch Right Now</h1>
              <p className='py-2 text-muted'>Watched Movies To Watch Right Now</p>
              <div className="brdr w-100 mt-3"></div>
            </div>
          </div>
          {trendingPeople.map((item, index) =>
            <div key={index} className="col-lg-2 col-md-4 col-sm-12 mb-3">
              <MediaItem key={index} item={item} />
            </div>
          )}
        </div>
      </>)
}
